export default "__VITE_ASSET__KtcZN44m__"